import React, { useMemo, useState } from 'react'
import Table from 'rc-table'
import { Divider, EInputTemplate, Input } from '../../components'
import {
  Container,
  FullWidth,
  Header,
  Title,
  StyledSort,
  TableWrapper,
  StyledRow,
  StyledHeader,
  StyledTable,
  StyledLink,
  CreateButton,
  StyledPagination,
  StyledEntity,
  Image,
  StyledSortName,
  SortImage,
  StyledButtonEnd,
  StyledButton,
} from './styled'
import { useTypedSelector } from '../../hooks'
import { RoutesTree } from '../../router'
import { Redirect } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { Service } from '../../services'
import { useTranslate } from '../../hooks/useTranslate'
import { Assets } from '../../assets'
import moment from 'moment'

export const Tags: React.FC = () => {
  const { t } = useTranslation('tags')
  const { user } = useTypedSelector(state => state.user)
  const { translate } = useTranslate()

  const [sortBy, setSortBy] = useState<string>('')
  const [order, setOrder] = useState<1 | -1>(-1)
  const [page, setPage] = useState<number>(1)

  const { data } = useSWR(
    [
      'get-tags',
      {
        ...(sortBy ? { sortBy } : {}),
        ...(order ? { order } : {}),
      },
    ],
    ([_, key]) => Service.Tag.getTags(key),
    {
      dedupingInterval: 0,
    },
  )

  if (!user?.access?.tags) {
    return <Redirect to={RoutesTree.notFound.path} />
  }

  // eslint-disable-next-line
  const total = useMemo(() => {
    return data?.totalCount ?? 0
  }, [data])

  const sort = (field: string) => {
    setSortBy(field)

    if (order == -1) {
      setOrder(1)
      return
    }

    setOrder(-1)
  }

  const columns = [
    {
      title: (
        <StyledSortName onClick={() => sort('title')}>
          <div>{t('title')}</div>

          <Divider width={10} />

          <SortImage
            src={
              sortBy == 'title' && order == 1
                ? Assets.UP_ARROW_ICON
                : Assets.DOWN_ARROW_ICON
            }
          />
        </StyledSortName>
      ),
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: (
        <StyledSortName onClick={() => sort('createdAt')}>
          <div>{t('createdAt')}</div>

          <Divider width={10} />

          <SortImage
            src={
              sortBy == 'createdAt' && order == 1
                ? Assets.UP_ARROW_ICON
                : Assets.DOWN_ARROW_ICON
            }
          />
        </StyledSortName>
      ),
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: t('details'),
      dataIndex: 'details',
      key: 'details',
    },
  ]

  return (
    <Container>
      <div>
        <Header>
          <Title>
            {t('tags')} ({data?.totalCount ?? 0})
          </Title>

          <CreateButton
            to={{
              pathname: '/tags/create',
            }}
          >
            {t('create')}
          </CreateButton>
        </Header>

        <Divider height={30} />

        <TableWrapper>
          {data?.models && (
            <Table
              columns={columns}
              data={data?.models?.map(tag => ({
                title: translate(tag?.title),
                createdAt: moment(tag?.createdAt).isValid()
                  ? moment(tag?.createdAt).format('HH:mm DD.MM.YYYY')
                  : '-',
                details: (
                  <StyledLink
                    to={{
                      pathname: `/tags/detail/${tag?._id}`,
                    }}
                  >
                    {t('details')}
                  </StyledLink>
                ),
              }))}
              scroll={{ y: 650 }}
              components={{
                body: {
                  row: StyledRow,
                },
                header: {
                  cell: StyledHeader,
                },
                table: StyledTable,
              }}
            />
          )}
        </TableWrapper>
      </div>

      <FullWidth>
        <StyledPagination>
          {page === 1 ? (
            <StyledButtonEnd> {t('back')}</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => setPage(prev => prev - 1)}>
              {t('back')}
            </StyledButton>
          )}

          <div>
            {page}/
            {!total
              ? 1
              : Math.ceil(total / 20) === 0
              ? 1
              : Math.ceil(total / 20)}
          </div>

          {1 === (!total ? 1 : Math.ceil(total / 20)) ? (
            <StyledButtonEnd>{t('next')}</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => setPage(prev => prev + 1)}>
              {t('next')}
            </StyledButton>
          )}
        </StyledPagination>
        <Divider height={10} />
      </FullWidth>
    </Container>
  )
}
